import { AdminLayout } from '@/components/layouts'
import { CategoryForm } from './CategoryForm'

interface Community {
  id: number
  name: string
}

interface ParentCategory {
  id: number
  name: string
  community_id: number
}

interface CategoryDetail {
  id: number
  slug: string
  name: string
  description: string | null
  position: number
  community_id: number | null
  parent_id: number | null
}

interface EditProps {
  category: CategoryDetail
  communities: Community[]
  parent_categories: ParentCategory[]
  max_position: number
}

export default function Edit({ category, communities, parent_categories, max_position }: EditProps) {
  return (
    <AdminLayout
      title={`Modifier "${category.name}"`}
      breadcrumbs={[
        { label: 'Catégories', href: '/admin/categories' },
        { label: category.name, href: `/admin/categories/${category.slug}` },
        { label: 'Modifier' }
      ]}
    >
      <div className="max-w-2xl">
        <CategoryForm
          category={{
            id: category.id,
            name: category.name,
            description: category.description || '',
            community_id: category.community_id || '',
            parent_id: category.parent_id,
            position: category.position
          }}
          communities={communities}
          parentCategories={parent_categories}
          maxPosition={max_position}
          onSubmit={`/admin/categories/${category.slug}`}
          isEdit
        />
      </div>
    </AdminLayout>
  )
}
